// extracted by mini-css-extract-plugin
export default {"invalidDataError":"Userrole_invalidDataError__hi+hO"};